import './assets/css/tailwind.css'
import DefaultLayout from '@/layout/DefaultLayout.vue';
import {createApp} from 'vue';
import App from './App.vue';
import i18n from './i18n'
import router from './router'

const app = createApp(App);

app.component('DefaultLayout', DefaultLayout);

router.beforeEach((to, from, next) => {
    const locale = to.meta.locale || 'el';
    localStorage.setItem('locale', locale);
    i18n.global.locale.value = locale;
    next();
});

app.use(router)
app.use(i18n)
app.mount('#app');
